import { render, staticRenderFns } from "./ConfigCardSupplierPopup.vue?vue&type=template&id=c0ea82f4&"
import script from "./ConfigCardSupplierPopup.vue?vue&type=script&lang=js&"
export * from "./ConfigCardSupplierPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports